export default __webpack_public_path__ + "static/radial-icon-map-global-f72caa8ee49c1c10892ff1c8503b7194.svg";